import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import IPageFromRails from './IPageFormRails';
import Loader from '@appComponents/Loader/Loader';
import ProcessedInvestments from '@profile/components/ProcessedInvestments/ProcessedInvestments';
import { classNames as cn } from '@features/utils/reactFunctions';

import * as style from './PageFromRailsStyles.module.scss'

export const PageFromRails = (props: IPageFromRails): JSX.Element => {
  const [showContent, setShowContent] = useState('');
  const { action } = props.match.params;
  const isPortfolio = action === 'portfolio';
  const isSecurity = action === 'security';

  useEffect(() => {
    Axios.get(props.match.url + '.json').then((resp) => {
      setShowContent(resp.data.partial);
    });
  }, [props.match.url]);

  return (
    <div id={action}>
      {!showContent
        ? <Loader fullWidth={true} />
        : (
          <div className={style.pageFromRails}>
            <div className={'gradient-header'}>
              <div/>
            </div>
            <div
              className={
                cn(
                  'fix-container-for-profile-react',
                  'gradient-header-covered',
                  isSecurity && 'fix-container-for-profile-react--security'
                )
              }
            >
              {isPortfolio && <ProcessedInvestments />}
              <div
                id={`js-${action}`}
                dangerouslySetInnerHTML={{ __html: showContent }}
              />
            </div>
          </div>
        )
      }
    </div>
  );
};

export default PageFromRails;
